import React from 'react'; //,{ useState, useEffect, useRef, createRef } 
import { FiX } from "react-icons/fi";

export default function DialogDesign({children}) {


    return (
        <div className='gradient-theme pos-relative dialog-frame'>

            {/* Dialog Content */}
            <div className='dialog-content-outer-bkg'>
                <div className='p-tb-50 dialog-content-bkg'>
                    {children}
                </div>
            </div>
        </div>
    )
}


